import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.div`
  background-color: ${COLOR.white};

  .paging > div {
    overflow: auto;
  }

  ${mobile(css`
    background-color: #fcfcfc;
  `)}
`;

const titleHeader = styled.div`
  text-align: center;

  h2 {
    position: relative;
    ${setFontStyle("Head3", "Bold")};
    color: ${COLOR.primaryBlue};
    background-color: ${COLOR.primaryBlue_10};
    padding: 16px 0;

    ${mobile(css`
      ${setFontStyle("Head6", "Bold")};
      color: ${COLOR.grayScale_800};
      background-color: ${COLOR.white};
    `)}
  }

  p.desc {
    ${setFontStyle("SubHead1")};
    color: ${COLOR.secondaryDeepBlue};
    background-color: ${COLOR.primaryBlue_10};
    padding: 14px 0;

    ${mobile(css`
      ${setFontStyle("SubHead4")};
      padding: 16px 0;
    `)}
  }

  .icon {
    display: none;

    ${mobile(css`
      display: block;
      position: absolute;
      left: 8px;
      top: calc(50% - 16px);
      cursor: pointer;
    `)}
  }
`;

const mainWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const mainContainer = styled.div`
  max-width: 997px;
  display: flex;

  ${mobile(css`
    width: 100%;
  `)}
`;

export default {
  container,
  titleHeader,
  mainWrapper,
  mainContainer,
};
